/* tslint:disable */
/* eslint-disable */
/**
 * pollination-server
 * Pollination Server OpenAPI Definition
 *
 * The version of the OpenAPI document: 1.6.2
 * Contact: info@pollination.cloud
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * RunsApi - axios parameter creator
 * @export
 */
export const RunsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Stop a run.
         * @summary Cancel a run
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRun: (owner_1, name_1, runId_1, ...args_1) => __awaiter(this, [owner_1, name_1, runId_1, ...args_1], void 0, function* (owner, name, runId, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('cancelRun', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('cancelRun', 'name', name);
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('cancelRun', 'runId', runId);
            const localVarPath = `/projects/{owner}/{name}/runs/{run_id}/cancel`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Get a download link for an artifact in a run folder
         * @summary Download an artifact from the run folder
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {string} [path] The path to an file within a project folder
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        downloadRunArtifact: (owner_1, name_1, runId_1, path_1, ...args_1) => __awaiter(this, [owner_1, name_1, runId_1, path_1, ...args_1], void 0, function* (owner, name, runId, path, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('downloadRunArtifact', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('downloadRunArtifact', 'name', name);
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('downloadRunArtifact', 'runId', runId);
            const localVarPath = `/projects/{owner}/{name}/runs/{run_id}/artifacts/download`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            if (path !== undefined) {
                localVarQueryParameter['path'] = path;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list all run steps
         * @summary Query the steps of a run
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRunSteps: (owner_1, name_1, runId_1, ...args_1) => __awaiter(this, [owner_1, name_1, runId_1, ...args_1], void 0, function* (owner, name, runId, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('getAllRunSteps', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getAllRunSteps', 'name', name);
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getAllRunSteps', 'runId', runId);
            const localVarPath = `/projects/{owner}/{name}/runs/{run_id}/all-steps`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a run.
         * @summary Get a Run
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRun: (owner_1, name_1, runId_1, ...args_1) => __awaiter(this, [owner_1, name_1, runId_1, ...args_1], void 0, function* (owner, name, runId, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('getRun', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getRun', 'name', name);
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getRun', 'runId', runId);
            const localVarPath = `/projects/{owner}/{name}/runs/{run_id}`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get run output by name
         * @summary Get run output by name
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {string} outputName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunOutput: (owner_1, name_1, runId_1, outputName_1, ...args_1) => __awaiter(this, [owner_1, name_1, runId_1, outputName_1, ...args_1], void 0, function* (owner, name, runId, outputName, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('getRunOutput', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getRunOutput', 'name', name);
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getRunOutput', 'runId', runId);
            // verify required parameter 'outputName' is not null or undefined
            assertParamExists('getRunOutput', 'outputName', outputName);
            const localVarPath = `/projects/{owner}/{name}/runs/{run_id}/outputs/{output_name}`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)))
                .replace(`{${"output_name"}}`, encodeURIComponent(String(outputName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get run step logs
         * @summary Get the logs of a specific step of the run
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {string} stepId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunStepLogs: (owner_1, name_1, runId_1, stepId_1, ...args_1) => __awaiter(this, [owner_1, name_1, runId_1, stepId_1, ...args_1], void 0, function* (owner, name, runId, stepId, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('getRunStepLogs', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getRunStepLogs', 'name', name);
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getRunStepLogs', 'runId', runId);
            // verify required parameter 'stepId' is not null or undefined
            assertParamExists('getRunStepLogs', 'stepId', stepId);
            const localVarPath = `/projects/{owner}/{name}/runs/{run_id}/steps/{step_id}/logs`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)))
                .replace(`{${"step_id"}}`, encodeURIComponent(String(stepId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * list run steps
         * @summary Query the steps of a run
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {StepStatusEnum} [status]
         * @param {Array<string>} [stepId]
         * @param {string} [untilGeneration]
         * @param {string} [sinceGeneration]
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRunSteps: (owner_1, name_1, runId_1, status_1, stepId_1, untilGeneration_1, sinceGeneration_1, page_1, perPage_1, ...args_1) => __awaiter(this, [owner_1, name_1, runId_1, status_1, stepId_1, untilGeneration_1, sinceGeneration_1, page_1, perPage_1, ...args_1], void 0, function* (owner, name, runId, status, stepId, untilGeneration, sinceGeneration, page, perPage, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('getRunSteps', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getRunSteps', 'name', name);
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getRunSteps', 'runId', runId);
            const localVarPath = `/projects/{owner}/{name}/runs/{run_id}/steps`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (stepId) {
                localVarQueryParameter['step_id'] = stepId;
            }
            if (untilGeneration !== undefined) {
                localVarQueryParameter['until_generation'] = untilGeneration;
            }
            if (sinceGeneration !== undefined) {
                localVarQueryParameter['since_generation'] = sinceGeneration;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a list of artifacts in a run folder
         * @summary List artifacts in a run folder
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {Array<string>} [path] The path to an file within a project folder
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listRunArtifacts: (owner_1, name_1, runId_1, path_1, page_1, perPage_1, ...args_1) => __awaiter(this, [owner_1, name_1, runId_1, path_1, page_1, perPage_1, ...args_1], void 0, function* (owner, name, runId, path, page, perPage, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('listRunArtifacts', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('listRunArtifacts', 'name', name);
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('listRunArtifacts', 'runId', runId);
            const localVarPath = `/projects/{owner}/{name}/runs/{run_id}/artifacts`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            if (path) {
                localVarQueryParameter['path'] = path;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a list of runs.
         * @summary List runs
         * @param {string} owner
         * @param {string} name
         * @param {Array<string>} [jobId]
         * @param {RunStatusEnum} [status]
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRuns: (owner_1, name_1, jobId_1, status_1, page_1, perPage_1, ...args_1) => __awaiter(this, [owner_1, name_1, jobId_1, status_1, page_1, perPage_1, ...args_1], void 0, function* (owner, name, jobId, status, page, perPage, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('listRuns', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('listRuns', 'name', name);
            const localVarPath = `/projects/{owner}/{name}/runs`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            if (jobId) {
                localVarQueryParameter['job_id'] = jobId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve a list of run results.
         * @summary Query run results
         * @param {string} owner
         * @param {string} name
         * @param {Array<string>} [jobId]
         * @param {RunStatusEnum} [status]
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryResults: (owner_1, name_1, jobId_1, status_1, page_1, perPage_1, ...args_1) => __awaiter(this, [owner_1, name_1, jobId_1, status_1, page_1, perPage_1, ...args_1], void 0, function* (owner, name, jobId, status, page, perPage, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('queryResults', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('queryResults', 'name', name);
            const localVarPath = `/projects/{owner}/{name}/results`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            if (jobId) {
                localVarQueryParameter['job_id'] = jobId;
            }
            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retry a run.
         * @summary Retry a run
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {RetryConfig} retryConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryRun: (owner_1, name_1, runId_1, retryConfig_1, ...args_1) => __awaiter(this, [owner_1, name_1, runId_1, retryConfig_1, ...args_1], void 0, function* (owner, name, runId, retryConfig, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('retryRun', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('retryRun', 'name', name);
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('retryRun', 'runId', runId);
            // verify required parameter 'retryConfig' is not null or undefined
            assertParamExists('retryRun', 'retryConfig', retryConfig);
            const localVarPath = `/projects/{owner}/{name}/runs/{run_id}/retry`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)))
                .replace(`{${"run_id"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(retryConfig, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * RunsApi - functional programming interface
 * @export
 */
export const RunsApiFp = function (configuration) {
    const localVarAxiosParamCreator = RunsApiAxiosParamCreator(configuration);
    return {
        /**
         * Stop a run.
         * @summary Cancel a run
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRun(owner, name, runId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelRun(owner, name, runId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RunsApi.cancelRun']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Get a download link for an artifact in a run folder
         * @summary Download an artifact from the run folder
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {string} [path] The path to an file within a project folder
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        downloadRunArtifact(owner, name, runId, path, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadRunArtifact(owner, name, runId, path, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RunsApi.downloadRunArtifact']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * list all run steps
         * @summary Query the steps of a run
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRunSteps(owner, name, runId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAllRunSteps(owner, name, runId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RunsApi.getAllRunSteps']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieve a run.
         * @summary Get a Run
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRun(owner, name, runId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRun(owner, name, runId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RunsApi.getRun']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * get run output by name
         * @summary Get run output by name
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {string} outputName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunOutput(owner, name, runId, outputName, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRunOutput(owner, name, runId, outputName, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RunsApi.getRunOutput']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * get run step logs
         * @summary Get the logs of a specific step of the run
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {string} stepId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunStepLogs(owner, name, runId, stepId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRunStepLogs(owner, name, runId, stepId, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RunsApi.getRunStepLogs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * list run steps
         * @summary Query the steps of a run
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {StepStatusEnum} [status]
         * @param {Array<string>} [stepId]
         * @param {string} [untilGeneration]
         * @param {string} [sinceGeneration]
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRunSteps(owner, name, runId, status, stepId, untilGeneration, sinceGeneration, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRunSteps(owner, name, runId, status, stepId, untilGeneration, sinceGeneration, page, perPage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RunsApi.getRunSteps']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieve a list of artifacts in a run folder
         * @summary List artifacts in a run folder
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {Array<string>} [path] The path to an file within a project folder
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listRunArtifacts(owner, name, runId, path, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRunArtifacts(owner, name, runId, path, page, perPage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RunsApi.listRunArtifacts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieve a list of runs.
         * @summary List runs
         * @param {string} owner
         * @param {string} name
         * @param {Array<string>} [jobId]
         * @param {RunStatusEnum} [status]
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRuns(owner, name, jobId, status, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRuns(owner, name, jobId, status, page, perPage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RunsApi.listRuns']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retrieve a list of run results.
         * @summary Query run results
         * @param {string} owner
         * @param {string} name
         * @param {Array<string>} [jobId]
         * @param {RunStatusEnum} [status]
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryResults(owner, name, jobId, status, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.queryResults(owner, name, jobId, status, page, perPage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RunsApi.queryResults']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Retry a run.
         * @summary Retry a run
         * @param {string} owner
         * @param {string} name
         * @param {string} runId
         * @param {RetryConfig} retryConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryRun(owner, name, runId, retryConfig, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.retryRun(owner, name, runId, retryConfig, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['RunsApi.retryRun']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * RunsApi - factory interface
 * @export
 */
export const RunsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = RunsApiFp(configuration);
    return {
        /**
         * Stop a run.
         * @summary Cancel a run
         * @param {RunsApiCancelRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRun(requestParameters, options) {
            return localVarFp.cancelRun(requestParameters.owner, requestParameters.name, requestParameters.runId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a download link for an artifact in a run folder
         * @summary Download an artifact from the run folder
         * @param {RunsApiDownloadRunArtifactRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        downloadRunArtifact(requestParameters, options) {
            return localVarFp.downloadRunArtifact(requestParameters.owner, requestParameters.name, requestParameters.runId, requestParameters.path, options).then((request) => request(axios, basePath));
        },
        /**
         * list all run steps
         * @summary Query the steps of a run
         * @param {RunsApiGetAllRunStepsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllRunSteps(requestParameters, options) {
            return localVarFp.getAllRunSteps(requestParameters.owner, requestParameters.name, requestParameters.runId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a run.
         * @summary Get a Run
         * @param {RunsApiGetRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRun(requestParameters, options) {
            return localVarFp.getRun(requestParameters.owner, requestParameters.name, requestParameters.runId, options).then((request) => request(axios, basePath));
        },
        /**
         * get run output by name
         * @summary Get run output by name
         * @param {RunsApiGetRunOutputRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunOutput(requestParameters, options) {
            return localVarFp.getRunOutput(requestParameters.owner, requestParameters.name, requestParameters.runId, requestParameters.outputName, options).then((request) => request(axios, basePath));
        },
        /**
         * get run step logs
         * @summary Get the logs of a specific step of the run
         * @param {RunsApiGetRunStepLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRunStepLogs(requestParameters, options) {
            return localVarFp.getRunStepLogs(requestParameters.owner, requestParameters.name, requestParameters.runId, requestParameters.stepId, options).then((request) => request(axios, basePath));
        },
        /**
         * list run steps
         * @summary Query the steps of a run
         * @param {RunsApiGetRunStepsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRunSteps(requestParameters, options) {
            return localVarFp.getRunSteps(requestParameters.owner, requestParameters.name, requestParameters.runId, requestParameters.status, requestParameters.stepId, requestParameters.untilGeneration, requestParameters.sinceGeneration, requestParameters.page, requestParameters.perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of artifacts in a run folder
         * @summary List artifacts in a run folder
         * @param {RunsApiListRunArtifactsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listRunArtifacts(requestParameters, options) {
            return localVarFp.listRunArtifacts(requestParameters.owner, requestParameters.name, requestParameters.runId, requestParameters.path, requestParameters.page, requestParameters.perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of runs.
         * @summary List runs
         * @param {RunsApiListRunsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRuns(requestParameters, options) {
            return localVarFp.listRuns(requestParameters.owner, requestParameters.name, requestParameters.jobId, requestParameters.status, requestParameters.page, requestParameters.perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a list of run results.
         * @summary Query run results
         * @param {RunsApiQueryResultsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryResults(requestParameters, options) {
            return localVarFp.queryResults(requestParameters.owner, requestParameters.name, requestParameters.jobId, requestParameters.status, requestParameters.page, requestParameters.perPage, options).then((request) => request(axios, basePath));
        },
        /**
         * Retry a run.
         * @summary Retry a run
         * @param {RunsApiRetryRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryRun(requestParameters, options) {
            return localVarFp.retryRun(requestParameters.owner, requestParameters.name, requestParameters.runId, requestParameters.retryConfig, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * RunsApi - object-oriented interface
 * @export
 * @class RunsApi
 * @extends {BaseAPI}
 */
export class RunsApi extends BaseAPI {
    /**
     * Stop a run.
     * @summary Cancel a run
     * @param {RunsApiCancelRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    cancelRun(requestParameters, options) {
        return RunsApiFp(this.configuration).cancelRun(requestParameters.owner, requestParameters.name, requestParameters.runId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Get a download link for an artifact in a run folder
     * @summary Download an artifact from the run folder
     * @param {RunsApiDownloadRunArtifactRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    downloadRunArtifact(requestParameters, options) {
        return RunsApiFp(this.configuration).downloadRunArtifact(requestParameters.owner, requestParameters.name, requestParameters.runId, requestParameters.path, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list all run steps
     * @summary Query the steps of a run
     * @param {RunsApiGetAllRunStepsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    getAllRunSteps(requestParameters, options) {
        return RunsApiFp(this.configuration).getAllRunSteps(requestParameters.owner, requestParameters.name, requestParameters.runId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a run.
     * @summary Get a Run
     * @param {RunsApiGetRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    getRun(requestParameters, options) {
        return RunsApiFp(this.configuration).getRun(requestParameters.owner, requestParameters.name, requestParameters.runId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get run output by name
     * @summary Get run output by name
     * @param {RunsApiGetRunOutputRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    getRunOutput(requestParameters, options) {
        return RunsApiFp(this.configuration).getRunOutput(requestParameters.owner, requestParameters.name, requestParameters.runId, requestParameters.outputName, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get run step logs
     * @summary Get the logs of a specific step of the run
     * @param {RunsApiGetRunStepLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    getRunStepLogs(requestParameters, options) {
        return RunsApiFp(this.configuration).getRunStepLogs(requestParameters.owner, requestParameters.name, requestParameters.runId, requestParameters.stepId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * list run steps
     * @summary Query the steps of a run
     * @param {RunsApiGetRunStepsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    getRunSteps(requestParameters, options) {
        return RunsApiFp(this.configuration).getRunSteps(requestParameters.owner, requestParameters.name, requestParameters.runId, requestParameters.status, requestParameters.stepId, requestParameters.untilGeneration, requestParameters.sinceGeneration, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a list of artifacts in a run folder
     * @summary List artifacts in a run folder
     * @param {RunsApiListRunArtifactsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    listRunArtifacts(requestParameters, options) {
        return RunsApiFp(this.configuration).listRunArtifacts(requestParameters.owner, requestParameters.name, requestParameters.runId, requestParameters.path, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a list of runs.
     * @summary List runs
     * @param {RunsApiListRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    listRuns(requestParameters, options) {
        return RunsApiFp(this.configuration).listRuns(requestParameters.owner, requestParameters.name, requestParameters.jobId, requestParameters.status, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a list of run results.
     * @summary Query run results
     * @param {RunsApiQueryResultsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    queryResults(requestParameters, options) {
        return RunsApiFp(this.configuration).queryResults(requestParameters.owner, requestParameters.name, requestParameters.jobId, requestParameters.status, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retry a run.
     * @summary Retry a run
     * @param {RunsApiRetryRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RunsApi
     */
    retryRun(requestParameters, options) {
        return RunsApiFp(this.configuration).retryRun(requestParameters.owner, requestParameters.name, requestParameters.runId, requestParameters.retryConfig, options).then((request) => request(this.axios, this.basePath));
    }
}
